"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var ButtomComponent_1 = __importDefault(require("../../components/Form/ButtomComponent"));
var ErrorBoundaryComponent_styled_1 = require("./ErrorBoundaryComponent.styled");
var system_1 = require("@mui/system");
var constants_1 = require("../../constants");
var context_1 = require("../../context");
function ErrorBoundaryComponent(_a) {
    var error = _a.error;
    console.log('Error::: ', error);
    var tokens = (0, context_1.useAuth)().tokens;
    var redirectToHome = function () {
        if (tokens) {
            window.location.href = constants_1.DASHBOARD_PATH;
        }
        else {
            window.location.href = '/';
        }
    };
    return ((0, jsx_runtime_1.jsx)(ErrorBoundaryComponent_styled_1.Wrapper, { children: (0, jsx_runtime_1.jsxs)(system_1.Box, __assign({ display: "grid", gap: "20px", sx: { placeItems: "center" } }, { children: [(0, jsx_runtime_1.jsx)(ErrorBoundaryComponent_styled_1.ImageError, { src: '/assets/images/robot.png', alt: "Error image" }), (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ variant: "h2" }, { children: "Huy! Algo sali\u00F3 mal" })), (0, jsx_runtime_1.jsx)(ButtomComponent_1.default.Filter, __assign({ variant: "outlined", color: "inherit", sx: { textTransform: 'uppercase' }, onClick: redirectToHome }, { children: "Regresar al Dashboard" }))] })) }));
}
exports.default = ErrorBoundaryComponent;
